import dJSON from 'dirty-json';

const moduleSelector = '.about-us-tabbed';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((module) => {
    if (module.classList.contains('single')) return;
    try {
      module.querySelector('script')?.remove();

      const { data } = dJSON.parse(module.data);
      const nav = module.querySelector('.about-us-tabbed__nav');
      const content = module.querySelector('.about-us-tabbed__content');

      // Determine initial active tab from URL hash (e.g. #lorem-ipsum)
      const { hash } = window.location;
      const activeIndex = data.findIndex((item) => `#${item.title.toLowerCase().replace(/ /g, '-')}` === hash);
      const initialActiveIndex = activeIndex >= 0 ? activeIndex : 0;

      // Build tabs and panels from data
      data.forEach((item, index) => {
        const tabHash = `#${item.title.toLowerCase().replace(/ /g, '-')}`;
        // Create tab button
        nav.insertAdjacentHTML('beforeend', `
          <a href="${tabHash}" class="btn-custom primary about-us-tabbed__nav--tab ${index === initialActiveIndex ? 'is-active' : ''}" data-tab-index="${index}">${item.title}</a>
        `);

        // Create content panel
        content.insertAdjacentHTML('beforeend', `
          <div class="about-us-tabbed__content__panel ${index === initialActiveIndex ? 'is-active' : ''}" data-panel-index="${index}">
            ${item.kicker ? `<h4 class="about-us-tabbed__content--kicker">${item.kicker}</h4>` : ''}
            <h2 class="about-us-tabbed__content--title">${item.title}</h2>
            <p class="about-us-tabbed__content--description">${item.description}</p>
            ${item.button_link && item.button_text ? `<a href="${item.button_link}" class="btn-custom primary">${item.button_text}</a>` : ''}
          </div>
        `);
      });

      // Tab click functionality
      const tabs = module.querySelectorAll('.about-us-tabbed__nav--tab');
      const panels = module.querySelectorAll('.about-us-tabbed__content__panel');

      const activateTabByHash = () => {
        const currentHash = window.location.hash;
        const matchingTab = Array.from(tabs).find((tab) => tab.getAttribute('href') === currentHash);
        if (matchingTab) {
          const index = matchingTab.dataset.tabIndex;
          tabs.forEach((t) => t.classList.remove('is-active'));
          panels.forEach((p) => p.classList.remove('is-active'));
          matchingTab.classList.add('is-active');
          module.querySelector(`[data-panel-index="${index}"]`).classList.add('is-active');
        }
      };

      window.addEventListener('hashchange', activateTabByHash);

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const index = tab.dataset.tabIndex;

          tabs.forEach((t) => t.classList.remove('is-active'));
          panels.forEach((p) => p.classList.remove('is-active'));

          tab.classList.add('is-active');
          module.querySelector(`[data-panel-index="${index}"]`).classList.add('is-active');

          window.history.replaceState(null, null, tab.getAttribute('href'));
        });
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
